let translateValue = 0;

/**
 * Handle scrollable text.
 *
 * @return {Void}
 */
const handleScrollable = () => {
	const scrollableElements = document.querySelectorAll('.js-scrollable p');

	if (! scrollableElements.length) {
		return;
	}

	scrollableElements[0].style.transform = `translateX(-${translateValue}px)`;
	scrollableElements[1].style.transform = `translateX(${translateValue}px)`;

	translateValue = window.scrollY / 10; // Buffer speed
};

window.addEventListener('scroll', () => {
	handleScrollable();
});
